export default __webpack_public_path__ + "static/media/chat11.5b6adb8e.png";